import React from 'react';
import { motion } from 'framer-motion';
import { fadeIn } from '../../utils/animations';
import Card from './Card';

const FeatureCard = ({ icon: Icon, title, description, className = '' }) => {
  return (
    <motion.div {...fadeIn}>
      <Card className={`text-center ${className}`}>
        <div className="mb-4 flex justify-center">
          <div className="w-16 h-16 rounded-full bg-gradient-primary flex items-center justify-center">
            <Icon className="text-white text-3xl" />
          </div>
        </div>
        <h3 className="text-xl font-bold mb-3 text-gray-900">{title}</h3>
        <p className="text-gray-600 leading-relaxed">{description}</p>
      </Card>
    </motion.div>
  );
};

export default FeatureCard;
